import React from "react";

const Footer = () => {
  return (
    <footer className="md:w-[55%] flex justify-between px-20 mt-64 pb-16">
      <div className="text-neon">10:23:17</div>
      <h3 className="text-neon">TOS</h3>
    </footer>
  );
};

export default Footer;
